import { Currency } from '../../../constants';
import { type WoocommercePaymentMethodValue } from '../../../constants/woocommerce/woocommerce';
import type {
  BillingAddress,
  FeeLine,
  ShippingAddress,
  ShippingLine,
  WooCommerceLineItem,
  WooCommerceOrderResponse,
} from '../../../model/woocommerce/woocommerce';

export interface CreateWooCommerceOrderRequest {
  cartToken: string;
  paymentMethod: WoocommercePaymentMethodValue;
  paymentMethodTitle: string;
  customerId?: number;
  status?: string;
  setPaid?: boolean;
  total: number;
  currency: Currency;
  shippingTotal: number;
  discountTotal: number;
  billing: BillingAddress;
  shipping: ShippingAddress;
  lineItems: WooCommerceLineItem[];
  shippingLines?: ShippingLine[];
  feeLines: FeeLine[];
  couponLines?: {
    code: string;
    discount: string;
  }[];
  paymentProcessInfo: {
    stripePaymentIntentId?: string;
  };
  utm?: {
    sourceType?: string; //type
    utmCampaign?: string; // cmp
    utmMedium?: string; //mdm
    utmSource?: string; //src
  };
}

export type CreateWooCommerceOrderResponse = WooCommerceOrderResponse;
